import { render } from "./VabeneAddUser.vue?vue&type=template&id=716a7967&ts=true"
import script from "./VabeneAddUser.vue?vue&type=script&lang=ts"
export * from "./VabeneAddUser.vue?vue&type=script&lang=ts"

import "./VabeneAddUser.vue?vue&type=style&index=0&id=716a7967&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__